import { render, staticRenderFns } from "./DepotStatus.vue?vue&type=template&id=09d8a9fd"
import script from "./DepotStatus.vue?vue&type=script&lang=js"
export * from "./DepotStatus.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports